import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

import { generateRandomUUID } from '@frontend/shared';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label: ReactNode;
  subLabel?: string;
};

export const CheckableInput = forwardRef<HTMLInputElement, Props>(
  ({ id, label, subLabel, className, ...rest }, ref) => {
    const _id = id || generateRandomUUID();

    return (
      <div className={twJoin('flex', className)}>
        <div className="flex items-center h-5">
          <input ref={ref} id={_id} type="checkbox" className="w-4 h-4 accent-blue-500 cursor-pointer" {...rest} />
        </div>
        <div className="text-sm">
          <label htmlFor={_id} className="font-medium text-gray-900 dark:text-white cursor-pointer pl-2">
            {label}
          </label>
          {subLabel ? (
            <p id="helper-checkbox-text" className="text-xs font-normal text-gray-500 dark:text-gray-300 pl-2">
              {subLabel}
            </p>
          ) : null}
        </div>
      </div>
    );
  },
);

CheckableInput.displayName = 'CheckableInput';
